"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMediaComponent = void 0;
const types_1 = require("../types");
const react_1 = __importDefault(require("react"));
const ConditionalOptimizer_1 = __importDefault(require("../wrappers/ConditionalOptimizer"));
const FieldRender_1 = __importDefault(require("../wrappers/FieldRender"));
const RepeatableRender_1 = __importDefault(require("../wrappers/RepeatableRender"));
const ValidationOptimizer_1 = __importDefault(require("../wrappers/ValidationOptimizer"));
const FileManagementRender_1 = require("../wrappers/FileManagementRender");
/**
 * This is a helper function to create the most typical type of Form component, one that supports conditional display,
 * repeatable fields, field level validation, and read only support
 * @param controlProvider The map of controls from which to grab the consumer's implementation
 * @param componentType the form component type name that we are building
 */
const generateMediaComponent = (controlProvider, componentType, translate) => {
    const NewComponent = (props) => {
        const Control = controlProvider[componentType];
        const { controlDefinition, controlPath } = props;
        return (react_1.default.createElement(ConditionalOptimizer_1.default, { conditionalMap: (0, types_1.isV2ConditionalComponent)(controlDefinition) ? controlDefinition.conditionalMap : undefined },
            react_1.default.createElement(RepeatableRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, renderControl: repeatableProps => {
                    return (react_1.default.createElement(ValidationOptimizer_1.default, { controlDefinition: controlDefinition, key: repeatableProps.key, render: validationFn => {
                            return (react_1.default.createElement(FieldRender_1.default, { controlPath: controlPath, controlDefinition: controlDefinition, validationFn: validationFn, render: fieldProps => {
                                    return (react_1.default.createElement(FileManagementRender_1.FileManagementRender, { controlDefinition: controlDefinition, onChange: fieldProps.onChange, value: fieldProps.value, render: fileProps => {
                                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                            //@ts-ignore
                                            return react_1.default.createElement(Control, Object.assign({}, fieldProps, repeatableProps, fileProps));
                                        } }));
                                } }));
                        }, translate: translate }));
                } })));
    };
    NewComponent.displayName = `ConditionalRepeatableValidatedField => ${componentType}`;
    return NewComponent;
};
exports.generateMediaComponent = generateMediaComponent;
